import React from 'react';
import { TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { IAccount } from '../../interfaces/accounting.interface';

interface Props {
    id: string;
    label: string;
    value: string;
    accounts: IAccount[];
    onChange: (accountId: string) => void;
    required?: boolean;
    size?: 'small' | 'medium';
    /** Text of the blank option, e.g. "Default" where blank means a fallback applies. */
    emptyLabel?: string;
}

/** Native select of accounts ("1010 · Bank account"), active accounts only. */
const AccountSelect: React.FC<Props> = ({ id, label, value, accounts, onChange, required, size = 'small', emptyLabel }) => {
    const { t } = useTranslation('accounting');
    return (
        <TextField
            id={id}
            select
            fullWidth
            size={size}
            label={label}
            value={value}
            required={required}
            onChange={e => onChange(e.target.value)}
            SelectProps={{ native: true }}
            InputLabelProps={{ shrink: true }}
        >
            <option value="">{emptyLabel ?? t('accountSelect.empty')}</option>
            {accounts.filter(a => a.active).map(a => (
                <option key={a.id} value={a.id}>{a.code} · {a.name}</option>
            ))}
        </TextField>
    );
};

export default AccountSelect;
